export const faqData = [
  {
    id: "faq-01",
    question: "What type of properties do you own?",
    answer: "Commercial, residential, and warehouse properties.",
    categories: ["all", "about"],
    keywords: "types properties commercial residential warehouse"
  },
  {
    id: "faq-02",
    question: "What does your residential property consist of?",
    answer: "Our residential property consists of:\n\n* Villas with 3, 4 and 5 bedrooms\n* Apartments from one- to two-bedroom units\n* Apartments suitable for individuals, couples and small families\n* Communal amenities",
    categories: ["all", "residential"],
    keywords: "residential villas apartments bedrooms families amenities living"
  },
  {
    id: "faq-03",
    question: "What does your commercial property consist of?",
    answer: "Our commercial property consists of:\n\n* Showrooms\n* Offices\n* Retail units\n* Warehouses",
    categories: ["all", "commercial"],
    keywords: "commercial showrooms offices retail warehouses business"
  },
  {
    id: "faq-04",
    question: "How many square meters (or square feet) are the villas that you have?",
    answer: "Villas range from approximately 2,000 to 6,000 square meters. Each property features spacious living areas, multiple bedrooms, landscaped gardens and premium amenities. Some villas may include private pools, guesthouses or additional service quarters depending on the unit.",
    categories: ["all", "residential"],
    keywords: "square meters feet size area villas pools guesthouses gardens"
  },
  {
    id: "faq-05",
    question: "What kind of amenities are you providing?",
    answer: "We provide:\n\n* Surveillance cameras\n* Garden areas\n* Private swimming pools\n* 24/7 security services\n* Other premium amenities",
    categories: ["all", "amenities"],
    keywords: "amenities security cameras pools gardens premium"
  },
  {
    id: "faq-06",
    question: "Where are the villas & apartments located?",
    answer: "Our residential locations include:\n\n* Al Garhoud\n* Rashidiya\n* Jumeirah 3\n* Al Hudaiba\n* Al Jafiliya",
    categories: ["all", "locations", "residential"],
    keywords: "locations where villas apartments garhoud rashidiya jumeirah hudaiba jafiliya"
  },
  {
    id: "faq-07",
    question: "Where are the showrooms, retail units, offices, and warehouses located?",
    answer: "Our commercial locations include:\n\n* Ras Al Khor\n* Al Quoz\n* Port Saeed\n* Al Jafiliya",
    categories: ["all", "locations", "commercial"],
    keywords: "locations where showrooms retail offices warehouses ras al khor quoz port saeed jafiliya"
  },
  {
    id: "faq-08",
    question: "Do you have varying rental prices for the different villas you offer?",
    answer: "Pricing depends on:\n\n* Location\n* Size\n* Specific property features\n\nFor example, Jumeirah is a higher-priced area compared with Rashidiya and Al Jafiliya.",
    categories: ["all", "pricing", "residential"],
    keywords: "price prices rental varying cost jumeirah rashidiya jafiliya"
  },
  {
    id: "faq-09",
    question: "What is the typical price range for the villas you offer?",
    answer: "**Jumeirah Villas**\nResidential: 500k to 600k\nCommercial: 500k to 800k\n\n**Other villas**\n175k to 300k",
    categories: ["all", "pricing", "residential", "commercial"],
    keywords: "price range typical cost villas jumeirah 500k 600k 800k 175k 300k"
  },
  {
    id: "faq-10",
    question: "What is the starting price for apartments?",
    answer: "Starting price is 60k, depending on type and location.",
    categories: ["all", "pricing", "residential"],
    keywords: "price starting cost apartments 60k"
  }
];
